import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { DxCoreUtils } from "../../dx-core/utiles/dx-core-utils";
import { DxDateTime } from "../../dx-core/utiles/dx-core-datetime-utils";
import { BdpkSchedulePeriodTypes } from "./bdpk-schedule-period.enum";
import { DxGridRow } from "../../dx-grid/domain/dx-grid-row";
let BdpkSchedule = class BdpkSchedule extends DxGridRow {
    constructor() {
        super(...arguments);
        this.fakeId = DxCoreUtils.randomHexaDecimal();
        /** Периодичность запуска **/
        this.periodId = 1;
        /** Дата запуска YYYY-MM-DD **/
        this.runDate = DxDateTime.dateTimeToStr(new Date(), 'YYYY-MM-DD');
        /** Время запуска HH:mm **/
        this.runTime = '12:00';
        /** День месяца **/
        this.monthDay = 1;
        /** День недели **/
        this.weekDayId = 1;
        this.objectPrivileges = [];
    }
    get id() {
        return this._id ? this._id : this.fakeId;
    }
    set id(value) {
        this._id = value;
    }
    get repeating() {
        return BdpkSchedulePeriodTypes.get(this.periodId).name;
    }
    getRowId() {
        return this.id;
    }
};
tslib_1.__decorate([
    jsonMember({ name: 'id', constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "objectId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "objectName", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "periodId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "createUserId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkSchedule.prototype, "createDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "changeUserId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkSchedule.prototype, "changeDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkSchedule.prototype, "lastLaunchFactDateTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "ord", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "runDate", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "runTime", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "cron", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Date, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Date)
], BdpkSchedule.prototype, "nextRun", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "monthDay", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], BdpkSchedule.prototype, "weekDayId", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "scheduleParams", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkSchedule.prototype, "humanReadableInterval", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], BdpkSchedule.prototype, "isPaused", void 0);
tslib_1.__decorate([
    jsonArrayMember(Number, { emitDefaultValue: false, preserveNull: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], BdpkSchedule.prototype, "objectPrivileges", void 0);
BdpkSchedule = tslib_1.__decorate([
    jsonObject
], BdpkSchedule);
export { BdpkSchedule };
